import { LoginPage, PasswordRecoveryPage, PasswordResetPage, RegisterPage } from '@features/auth'
import { ProfilePage } from '@features/user-profile'
import { LoadingOverlay } from '@shared/components/feedback'
import { AnalyticsRouteTracker } from '@shared/components/AnalyticsRouteTracker'
import { Layout } from '@shared/components/layout'
import { InstallPromptDialog } from '@shared/components/pwa'
import { ProtectedRoute, PublicRoute } from '@shared/components/routes'
import { PWAProvider, useLoading, usePWA } from '@shared/contexts'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { NotFoundPage } from '../pages/NotFoundPage'
import { ProfessionalDetailPage } from '../pages/ProfessionalDetailPage'
import { ProfessionalsPage } from '../pages/ProfessionalsPage'
import { ProfessionsPage } from '../pages/ProfessionsPage'

function AppContent() {
  // PWA Install functionality from context
  const { isPromptVisible, promptInstall, dismissPrompt } = usePWA()

  // Loading state
  const { isLoading, message } = useLoading()

  // Handle install from dialog
  const handleInstallFromDialog = async () => {
    const accepted = await promptInstall()
    if (!accepted) {
      // User dismissed the native prompt, dismiss the dialog too
      dismissPrompt()
    }
    // If accepted, app will be installed and dialog will auto-hide
  }

  return (
    <>
      {/* Global Loading Overlay */}
      <LoadingOverlay isVisible={isLoading} message={message} />

      {/* Install Prompt Dialog (shows every 15 days if not installed) */}
      <InstallPromptDialog
        open={isPromptVisible}
        onInstall={() => void handleInstallFromDialog()}
        onDismiss={dismissPrompt}
      />

      <AnalyticsRouteTracker />

      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<ProfessionsPage />} />
          <Route path="/professions" element={<ProfessionsPage />} />
          <Route path="/professionals/:professionId" element={<ProfessionalsPage />} />
          <Route path="/professional/:id" element={<ProfessionalDetailPage />} />

          {/* Auth Routes (redirect if already authenticated) */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            }
          />
          <Route
            path="/passwordrecovery"
            element={
              <PublicRoute>
                <PasswordRecoveryPage />
              </PublicRoute>
            }
          />
          <Route path="/resetPassword" element={<PasswordResetPage />} />

          {/* Protected Routes (require authentication) */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />

          {/* 404 Catch-all */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <PWAProvider>
        <AppContent />
      </PWAProvider>
    </BrowserRouter>
  )
}

export default App
